import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { actions } from '../../StockAdjustmentInBatchState'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'

export default ({
  totalAdjustments, adjustmentId, showModal, setShowModal, decision,
}) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const confirmAdjustments = () => {
    setShowModal(false)
    dispatch(actions.confirmPendingAdjustments({ adjustmentId, history, decision }))
  }

  return (
    <ConfirmOrRejectModal
      show={showModal}
      title='Aceitar todos os ajustes'
      description={`Você tem certeza que deseja realizar o ajuste de ${totalAdjustments} produtos?`}
      onConfirm={confirmAdjustments}
      onReject={() => setShowModal(false)}
      onClose={() => setShowModal(false)}
    />
  )
}
